<template>
  <b-form-group
    id="input-group-1"
    label="Estado de Pago"
    label-for="formrow-inputState"
  >
    <b-row>
      <b-col sm="12"
             md="11"
             lg="11">
        <b-form-select
          id="formrow-inputState"
          value-field="estadoDePago"
          :options="payStates"
          type="text"
          v-model="payState"
          @change="$emit('change', {});"
        ></b-form-select>
      </b-col>
      <b-col lg="1" class="icon">
        <i
            class="hand bx bx-x font-size-24"
            @click="clear"
        />
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
import PayService from "./payService";

export default {
  props: {
    value: Number
  },
  data: function () {
    return {
      payStates: [],
      payState: this.value
    }
  },
  beforeMount () {
    this.getPay();
  },
  methods: {
    getPay () {
      let payRequest;
      payRequest = PayService['getPayStates'](this.$store.state.rutEmpresa.cuentaSeleccionada.value)
      payRequest.then(payStates => this.payStates = payStates)
        .catch(err => console.log(err));
    },
    clear () {
      this.payStates = []
      this.payState = 0
      this.getPay()
      this.$emit("change", {});
    }
  },
  watch: {
    payState (newVal) {
      this.$emit("input", newVal);
      this.$emit("change", {});
    },
  }
}
</script>

<style>
.hand {
  cursor: pointer;
}
.icon {
  margin-left: -25px;
  margin-top: 5px;
}
</style>
